export type AttributeChangeCallback = (old: string, value: string) => any;
export abstract class ABSHtmlElement extends HTMLElement{
    private readonly callbacks: Map<string, AttributeChangeCallback[]> = new Map();
    protected constructor(){
        super();
    }
    protected onAttributeChange(name: string, callback: AttributeChangeCallback){
        if(this.callbacks.has(name)) this.callbacks.get(name)!.push(callback);
        else this.callbacks.set(name, [callback]);
        return this;
    }
    protected static observedAttributes: string[] = [];
    private attributeChangedCallback(attributeName: string, oldValue: string, newValue: string) {
        this.callbacks.get(attributeName)?.forEach(c=>c(oldValue, newValue));
    }
    protected abstract connectedCallback(): any;
    protected disconnectedCallback(){}
}